import EyeStrikeFullZone from './EyeStrikeFullZone';

export default EyeStrikeFullZone;
